import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenGroupEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    public groups() {
        return `${this.getApiServerUrl()}/asset-groups`;
    }

    groupsHierarchy() {
        return `${this.getApiServerUrl()}/asset-groups-hierarchy`;
    }
}
